<!--Workflow-->
<mat-form-field class="cm-infos-field">
    <mat-select name="exportWorkflow" placeholder="Workflow" [ngModel]="$selectedExportWorkflow()" (ngModelChange)="$selectedExportWorkflow.set($event)">
        @for (exportWorkflow of exportWorkflows; track exportWorkflow) {
            <mat-option [value]="exportWorkflow">{{ workflowToString(exportWorkflow) }} </mat-option>
        }
    </mat-select>
</mat-form-field>
<!--Engine-->
<mat-form-field class="cm-infos-field">
    <mat-select name="exportEngine" placeholder="Engine" [ngModel]="$selectedExportEngine()" (ngModelChange)="$selectedExportEngine.set($event)">
        @for (exportEngine of exportEngines; track exportEngine) {
            <mat-option [value]="exportEngine">{{ engineToString(exportEngine) }} </mat-option>
        }
    </mat-select>
</mat-form-field>
<!--NormalY-->
<mat-form-field class="cm-infos-field">
    <mat-select name="exportNormalY" placeholder="Normal" [ngModel]="$selectedExportNormalY()" (ngModelChange)="$selectedExportNormalY.set($event)">
        @for (exportNormalY of exportNormalsY; track exportNormalY) {
            <mat-option [value]="exportNormalY">
                {{ normalYToString(exportNormalY) }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
<!--Format-->
<mat-form-field class="cm-infos-field">
    <mat-select name="exportFormat" placeholder="Format" [ngModel]="$selectedExportFormat()" (ngModelChange)="$selectedExportFormat.set($event)">
        @for (exportFormat of exportFormats; track exportFormat) {
            <mat-option [value]="exportFormat">
                {{ exportFormat | uppercase }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
<!--Format-->
<mat-form-field class="cm-infos-field">
    <mat-select
        name="exportResolution"
        placeholder="Resolution"
        [ngModel]="$selectedExportResolution()"
        (ngModelChange)="$selectedExportResolution.set($event)"
    >
        @for (exportResolution of exportResolutions; track exportResolution) {
            <mat-option [value]="exportResolution">
                {{ resolutionToString(exportResolution) }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
<button
    class="cm-button"
    [matTooltip]="$isDuplicate() ? 'This material already has an export with these settings' : 'Export with current settings'"
    (click)="submit()"
    [disabled]="$isLoading() || $isDuplicate()"
>
    Create custom export
    @if ($isLoading()) {
        <cm-loading-spinner-icon></cm-loading-spinner-icon>
    } @else {
        <i class="fa-regular fa-play"></i>
    }
</button>
